import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49d312df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "navbar-brand" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "logo",
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.0",
  width: "700.000000pt",
  height: "700.000000pt",
  viewBox: "0 0 700.000000 700.000000",
  preserveAspectRatio: "xMidYMid meet"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    transform: "translate(0.000000,700.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none",
    style: {"fill":"#eee"}
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M1510 6389 c-78 -9 -135 -35 -174 -81 -82 -96 -79 -271 6 -359 77 -79 11 -73 972 -79 l859 -5 0 -1694 0 -1694 -66 -24 c-169 -60 -290 -186 -338 -350 -21 -70 -29 -230 -16 -303 26 -142 89 -309 160 -418 24 -37 102 -135 173 -217 186 -216 258 -322 314 -465 28 -71 46 -90 85 -90 40 0 54 16 90 105 61 152 158 290 350 500 59 65 140 176 174 240 31 57 86 201 95 248 3 12 10 47 16 77 16 80 14 235 -4 303 -41 151 -142 275 -277 339 -41 20 -87 40 -104 45 l-30 10 0 1693 c0 1121 3 1694 10 1696 5 2 393 5 860 6 l850 3 52 29 c87 48 123 118 123 236 0 133 -72 220 -203 246 -41 9 -3904 11 -3977 3z" })
  ])
], -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navbar-end" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "navbar-item",
    href: "https://transfo.backend.bubbly-doo.com",
    target: "_blank"
  }, "Transfo"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "navbar-item",
    href: "https://builder.backend.bubbly-doo.com",
    target: "_blank"
  }, "Builder"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "navbar-item",
    href: "https://color-picker.backend.bubbly-doo.com",
    target: "_blank"
  }, "Color Picker")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createVNode(_component_Menu)
      ])
    ]),
    (_ctx.currentProject && _ctx.currentPackage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.currentProject.name) + " " + _toDisplayString(_ctx.currentPackage.version), 1))
      : _createCommentVNode("", true),
    _hoisted_5
  ]))
}